import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BannerComponent } from '../../shared/components/banner/banner.component';
import { MainLayoutComponent } from '../../shared/components/layouts/main-layout/main-layout.component';
import { Themes } from '../../../themes';

@Component({
  selector: 'ez-verification-error',
  imports: [BannerComponent, MainLayoutComponent],
  templateUrl: './verification-error.component.html',
  styleUrl: './verification-error.component.scss',
})
export class VerificationErrorComponent {
  private titleService = inject(Title);

  constructor() {
    this.titleService.setTitle('Verifizierung nicht möglich');
  }

  Themes = Themes;
}
